import builder from './builder';
import urls from './urls';
import types from './types';

export default {
  builder,
  types,
  urls,
};
